<template>
  <el-main class="main-con el-main">
    <router-view />
  </el-main>
</template>

<script>
    export default {
        name: "CustomerUser"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/lender/CustomerAdmin/CustomerUser.vue